import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type {
  SettlementOverview,
  SettlementParams,
} from '~/features/dashboard/types/settlement.type';

/**
 * 전체 정산 결과 조회
 * @endpoint GET /admin/dashboard/settlement/overview
 */
export function getSettlementOverviewApi(params: SettlementParams) {
  return axiosInstance.get<ApiResponse<SettlementOverview>>(
    '/admin/dashboard/settlement/overview',
    {
      params: {
        startDate: params.startsAt,
        endDate: params.endsAt,
      },
    },
  );
}
